import { randomId } from '../utils/randomId.js';

export const createWorkflow = ({ workflow = {}, userId, companyId, integrationId, meta }) => {
  const workflowId = randomId(12, 'all');

  return {
    id: workflowId,
    workflow,
    meta,
    userId,
    companyId,
    integrationId
  };
};
